// Notify handler
import { notifyHandlerActions } from '../../../lib/notify-handler';
export const { CATCH_NOTIFY_HANDLER } = notifyHandlerActions;

// API handler
export const AJAX_ERROR = 'AJAX_ERROR';

// Service Setting
export const START_FETCH_SERVICE_SETTING = 'START_FETCH_SERVICE_SETTING';
export const FETCH_SERVICE_SETTING_SUCCESS = 'FETCH_SERVICE_SETTING_SUCCESS';
export const FETCH_SERVICE_SETTING_FAILED = 'FETCH_SERVICE_SETTING_FAILED';

export const UPDATE_SERVICE_SETTING = 'UPDATE_SERVICE_SETTING';

// Platform Setting
export const START_FETCH_PLATFORM_SETTING = 'START_FETCH_PLATFORM_SETTING';
export const FETCH_PLATFORM_SETTING_SUCCESS = 'FETCH_PLATFORM_SETTING_SUCCESS';
export const FETCH_PLATFORM_SETTING_FAILED = 'FETCH_PLATFORM_SETTING_FAILED';

export const UPDATE_PLATFORM_STATUS = 'UPDATE_PLATFORM_STATUS';
export const UPDATE_PLATFORM_SETTING_MAINTENANCE = 'UPDATE_PLATFORM_SETTING_MAINTENANCE';

// Auth
export const START_ID_LOGIN = 'START_ID_LOGIN';
export const ID_LOGIN_SUCCESS = 'ID_LOGIN_SUCCESS';
export const ID_LOGIN_FAILED = 'ID_LOGIN_FAILED';

export const START_ANONYMOUS_LOGIN = 'START_ANONYMOUS_LOGIN';
export const ANONYMOUS_LOGIN_SUCCESS = 'ANONYMOUS_LOGIN_SUCCESS';
export const ANONYMOUS_LOGIN_FAILED = 'ANONYMOUS_LOGIN_FAILED';

export const START_CHECK_AUTH = 'START_CHECK_AUTH';
export const CHECK_AUTH_SUCCESS = 'CHECK_AUTH_SUCCESS';
export const CHECK_AUTH_FAILED = 'CHECK_AUTH_FAILED';

export const SET_JWT = 'SET_JWT';
export const SAVE_JWT_TO_LOCAL_STORAGE = 'SAVE_JWT_TO_LOCAL_STORAGE';
export const CLEAR_JWT = 'CLEAR_JWT';

export const SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE = 'SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE';
export const CLEAR_CLIENT_LOGIN_CODE = 'CLEAR_CLIENT_LOGIN_CODE';

export const START_UPDATE_ME_LANGUAGE_CODE = 'START_UPDATE_ME_LANGUAGE_CODE';
export const UPDATE_ME_LANGUAGE_CODE_SUCCESS = 'UPDATE_ME_LANGUAGE_CODE_SUCCESS';
export const UPDATE_ME_LANGUAGE_CODE_FAILED = 'UPDATE_ME_LANGUAGE_CODE_FAILED';

// Sound
export const INIT_SOUND_STATUS = 'INIT_SOUND_STATUS';

// Language
export const SET_LANGUAGE = 'SET_LANGUAGE';

// Articles
export const START_FETCH_ARTICLES = 'START_FETCH_ARTICLES';
export const FETCH_ARTICLES_SUCCESS = 'FETCH_ARTICLES_SUCCESS';
export const FETCH_ARTICLES_FAILED = 'FETCH_ARTICLES_FAILED';

// Conversation
export const START_FETCH_CONVERSATION = 'START_FETCH_CONVERSATION';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_FAILED = 'FETCH_CONVERSATION_FAILED';

export const START_CREATE_CONVERSATION = 'START_CREATE_CONVERSATION';
export const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS';
export const CREATE_CONVERSATION_FAILED = 'CREATE_CONVERSATION_FAILED';

export const START_CREATE_NORMAL_REPLY_CONVERSATION = 'START_CREATE_NORMAL_REPLY_CONVERSATION';
export const CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS = 'CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS';
export const CREATE_NORMAL_REPLY_CONVERSATION_FAILED = 'CREATE_NORMAL_REPLY_CONVERSATION_FAILED';

export const START_CREATE_QUICK_PATH_CONVERSATION = 'START_CREATE_QUICK_PATH_CONVERSATION';
export const CREATE_QUICK_PATH_CONVERSATION_SUCCESS = 'CREATE_QUICK_PATH_CONVERSATION_SUCCESS';
export const CREATE_QUICK_PATH_CONVERSATION_FAILED = 'CREATE_QUICK_PATH_CONVERSATION_FAILED';

export const START_CREATE_SMART_REPLY_CONVERSATION = 'START_CREATE_SMART_REPLY_CONVERSATION';
export const CREATE_SMART_REPLY_CONVERSATION_SUCCESS = 'CREATE_SMART_REPLY_CONVERSATION_SUCCESS';
export const CREATE_SMART_REPLY_CONVERSATION_FAILED = 'CREATE_SMART_REPLY_CONVERSATION_FAILED';

export const START_UPDATE_CONVERSATION_TEXT_SIZE = 'START_UPDATE_CONVERSATION_TEXT_SIZE';
export const UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS = 'UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS';
export const UPDATE_CONVERSATION_TEXT_SIZE_FAILED = 'UPDATE_CONVERSATION_TEXT_SIZE_FAILED';

export const START_CLOSE_CONVERSATION = 'START_CLOSE_CONVERSATION';
export const CLOSE_CONVERSATION_SUCCESS = 'CLOSE_CONVERSATION_SUCCESS';
export const CLOSE_CONVERSATION_FAILED = 'CLOSE_CONVERSATION_FAILED';

export const START_GRADE_CONVERSATION_SCORE = 'START_GRADE_CONVERSATION_SCORE';
export const GRADE_CONVERSATION_SCORE_SUCCESS = 'GRADE_CONVERSATION_SCORE_SUCCESS';
export const GRADE_CONVERSATION_SCORE_FAILED = 'GRADE_CONVERSATION_SCORE_FAILED';

export const START_CLEAR_CONVERSATION_SESSION = 'START_CLEAR_CONVERSATION_SESSION';
export const CLEAR_CONVERSATION_SESSION_SUCCESS = 'CLEAR_CONVERSATION_SESSION_SUCCESS';
export const CLEAR_CONVERSATION_SESSION_FAILED = 'CLEAR_CONVERSATION_SESSION_FAILED';

export const CLEARED_CONVERSATION_SESSION_EVENT = 'CLEARED_CONVERSATION_SESSION_EVENT';

export const UPDATE_CONVERSATION_STATUS = 'UPDATE_CONVERSATION_STATUS';

export const UPDATE_CONVERSATION_COLOR_MAPPING = 'UPDATE_CONVERSATION_COLOR_MAPPING';

export const UPDATE_CONVERSATION_TEXT_SIZE_EVENT = 'UPDATE_CONVERSATION_TEXT_SIZE_EVENT';

export const RESET_CONVERSATION = 'RESET_CONVERSATION';

// Conversation Reply
export const START_FETCH_CONVERSATION_REPLIES = 'START_FETCH_CONVERSATION_REPLIES';
export const FETCH_CONVERSATION_REPLIES_SUCCESS = 'FETCH_CONVERSATION_REPLIES_SUCCESS';
export const FETCH_CONVERSATION_REPLIES_FAILED = 'FETCH_CONVERSATION_REPLIES_FAILED';

export const START_FETCH_NEXT_CONVERSATION_REPLIES = 'START_FETCH_NEXT_CONVERSATION_REPLIES';
export const FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS = 'FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS';
export const FETCH_NEXT_CONVERSATION_REPLIES_FAILED = 'FETCH_NEXT_CONVERSATION_REPLIES_FAILED';

export const START_CREATE_TEXT_CONVERSATION_REPLY = 'START_CREATE_TEXT_CONVERSATION_REPLY';
export const CREATE_TEXT_CONVERSATION_REPLY_SUCCESS = 'CREATE_TEXT_CONVERSATION_REPLY_SUCCESS';
export const CREATE_TEXT_CONVERSATION_REPLY_FAILED = 'CREATE_TEXT_CONVERSATION_REPLY_FAILED';

export const START_CREATE_FILE_CONVERSATION_REPLY = 'START_CREATE_FILE_CONVERSATION_REPLY';
export const CREATE_FILE_CONVERSATION_REPLY_SUCCESS = 'CREATE_FILE_CONVERSATION_REPLY_SUCCESS';
export const CREATE_FILE_CONVERSATION_REPLY_FAILED = 'CREATE_FILE_CONVERSATION_REPLY_FAILED';

export const START_CREATE_FORM_FILE_CONVERSATION_REPLY = 'START_CREATE_FORM_FILE_CONVERSATION_REPLY';
export const CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS = 'CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS';
export const CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED = 'CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED';

export const START_SELECT_CONVERSATION_TAG = 'START_SELECT_CONVERSATION_TAG';
export const SELECT_CONVERSATION_TAG_SUCCESS = 'SELECT_CONVERSATION_TAG_SUCCESS';
export const SELECT_CONVERSATION_TAG_FAILED = 'SELECT_CONVERSATION_TAG_FAILED';

export const START_SELECT_CONVERSATION_QA_OPTION = 'START_SELECT_CONVERSATION_QA_OPTION';
export const SELECT_CONVERSATION_QA_OPTION_SUCCESS = 'SELECT_CONVERSATION_QA_OPTION_SUCCESS';
export const SELECT_CONVERSATION_QA_OPTION_FAILED = 'SELECT_CONVERSATION_QA_OPTION_FAILED';

export const START_CREATE_CONVERSATION_FORM_REPLY = 'START_CREATE_CONVERSATION_FORM_REPLY';
export const CREATE_CONVERSATION_FORM_REPLY_SUCCESS = 'CREATE_CONVERSATION_FORM_REPLY_SUCCESS';
export const CREATE_CONVERSATION_FORM_REPLY_FAILED = 'CREATE_CONVERSATION_FORM_REPLY_FAILED';

export const START_SEND_TYPEING_CONVERSATION_REPLY = 'START_SEND_TYPEING_CONVERSATION_REPLY';
export const SEND_TYPEING_CONVERSATION_REPLY_SUCCESS = 'SEND_TYPEING_CONVERSATION_REPLY_SUCCESS';

export const APPEND_CONVERSATION_REPLIES = 'APPEND_CONVERSATION_REPLIES';

export const RECEIVE_CONVERSATION_REPLY = 'RECEIVE_CONVERSATION_REPLY';
export const RECEIVE_UPDATED_CONVERSATION_REPLY = 'RECEIVE_UPDATED_CONVERSATION_REPLY';

export const RESET_CONVERSATION_REPLY = 'RESET_CONVERSATION_REPLY';

export const UPDATE_CONVERSATION = 'UPDATE_CONVERSATION';

export const START_RESET_CONVERSATION_SMART_REPLY = 'START_RESET_CONVERSATION_SMART_REPLY';
export const RESET_CONVERSATION_SMART_REPLY_SUCCESS = 'RESET_CONVERSATION_SMART_REPLY_SUCCESS';

export const START_CONTACT_CS_CONVERSATION = 'START_CONTACT_CS_CONVERSATION';
export const CONTACT_CS_CONVERSATION_SUCCESS = 'CONTACT_CS_CONVERSATION_SUCCESS';
export const CONTACT_CS_CONVERSATION_FAILED = 'CONTACT_CS_CONVERSATION_FAILED';

export const START_CREATE_CONVERSATION_QA_FORM_REPLY = 'START_CREATE_CONVERSATION_QA_FORM_REPLY';
export const CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS = 'CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS';
export const CREATE_CONVERSATION_QA_FORM_REPLY_FAILED = 'CREATE_CONVERSATION_QA_FORM_REPLY_FAILED';

export const START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY = 'START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY';
export const CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS = 'CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS';
export const CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED = 'CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED';

export const START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY = 'START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY';
export const CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS = 'CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS';
export const CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED = 'CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED';

export const START_CREATE_QUICK_FORM_CONVERSATION_REPLY = 'START_CREATE_QUICK_FORM_CONVERSATION_REPLY';
export const CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS = 'CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS';
export const CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED = 'CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED';

// Application
export const START_FORCE_DISCONNECT_SOCKET = 'START_FORCE_DISCONNECT_SOCKET';
export const FORCE_DISCONNECT_SOCKET_SUCCESS = 'FORCE_DISCONNECT_SOCKET_SUCCESS';

export const START_FORCE_CONNECT_SOCKET = 'START_FORCE_CONNECT_SOCKET';
export const FORCE_CONNECT_SOCKET_SUCCESS = 'FORCE_CONNECT_SOCKET_SUCCESS';

export const START_FORCE_RECONNECT_SOCKET = 'START_FORCE_RECONNECT_SOCKET';
export const FORCE_RECONNECT_SOCKET_SUCCESS = 'FORCE_RECONNECT_SOCKET_SUCCESS';

export const RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT = 'RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT';
export const RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT = 'RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT';

export const NAVIGATE_TO_OVER_PAGE = 'NAVIGATE_TO_OVER_PAGE';

// Translate
export const START_TRANSLATE_TEXTS = 'START_TRANSLATE_TEXTS';
export const START_TRANSLATE_TEXTS_SUCCESS = 'START_TRANSLATE_TEXTS_SUCCESS';
export const START_TRANSLATE_TEXTS_FAILED = 'START_TRANSLATE_TEXTS_FAILED';

// Me
export const START_FETCH_ME = 'START_FETCH_ME';
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS';
export const FETCH_ME_FAILED = 'FETCH_ME_FAILED';

// Conversation Error
export const GET_CONVERSATION_SILENCE = 'GET_CONVERSATION_SILENCE';
export const RESET_CONVERSATION_SILENCE = 'RESET_CONVERSATION_SILENCE';

// Captcha
export const START_FETCH_CAPTCHA = 'START_FETCH_CAPTCHA';
export const FETCH_CAPTCHA_SUCCESS = 'FETCH_CAPTCHA_SUCCESS';
export const FETCH_CAPTCHA_FAILED = 'FETCH_CAPTCHA_FAILED';

export const START_DETECT_CAPTCHA = 'START_DETECT_CAPTCHA';
export const DETECT_CAPTCHA_SUCCESS = 'DETECT_CAPTCHA_SUCCESS';
export const DETECT_CAPTCHA_FAILED = 'DETECT_CAPTCHA_FAILED';

// Heartbeat
export const START_HEARTBEAT = 'START_HEARTBEAT';
export const STOP_HEARTBEAT = 'STOP_HEARTBEAT';

// Preview Image
export const SET_PREVIEW_IMAGE = 'SET_PREVIEW_IMAGE';

// Quotation
export const SET_QUOTATION = 'SET_QUOTATION';
export const RESET_QUOTATION = 'RESET_QUOTATION';

// Logger
export const TRIGGER_LOG_EVENT = 'TRIGGER_LOG_EVENT';
